<template>
  <div :style="style.main">
    <!-- header tools -->
    <div :style="style.header">
      <div :style="style.textTitle" v-text="config.title"></div>
      <div>
        <button :style="style.font.s18" @click="printDoc">Imprimir</button>
        &nbsp;&nbsp;
        <button :style="style.font.s18" @click="downloadDoc">Descargar</button>
        &nbsp;&nbsp;
        <button v-if="sendEmail" :style="style.font.s18" @click="sendEmailDoc">
          Enviar Correo
        </button>
        &nbsp;&nbsp;
        <button
          v-if="downloadJson"
          :style="style.font.s18"
          @click="downloadJsonDoc"
        >
          Descargar JSON
        </button>

        <!-- more tools slot -->
        <slot name="tools"></slot>
      </div>

      <!-- loading slot -->
      <div v-if="loading">
        <slot name="loading">Cargando...</slot>
      </div>

      <div v-if="rendering.percent !== 100.0">
        <slot name="loading">{{ renderingMsg }}</slot>
      </div>
    </div>
    <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;" v-if="mailLabel">
        <center>
            {{ mailLabel }}
        </center>
    </div>

    <!-- document container -->
    <div :style="style.docContainer">
      <div ref="dataprint" :style="style.ma0">
        <!-- pages slot -->
        <slot name="pages" :config="pageConfig"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import { font, text } from "./styles";

export default {
  name: "PreviewDocument",

  props: {
    config: {
      type: Object,
      default: () => ({
        title: "",
        filename: "archivo.pdf",
        margins: [10, 10, 10, 10],
        unit: "mm",
        format: "letter",
        orientation: "p",
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    sendEmail: {
      type: Boolean,
      default: false,
    },
    downloadJson: {
      type: Boolean,
      default: false,
    },
    mailLabel: {
      type:String,
      default: null
    }
  },

  data: () => ({
    rendering: { progress: 0, total: 0, percent: 100, text: "" },
    style: {
      font,
      main: {
        ...font.family,
        margin: 0,
        display: "flex",
        "flex-direction": "column",
        "min-height": "100vh",
      },
      header: { padding: "10px", ...text.center },
      textTitle: { ...font.s30, "margin-bottom": "10px" },
      docContainer: {
        margin: 0,
        padding: 0,
        "background-color": "#696969",
        "flex-grow": 1,
      },
      ma0: { margin: 0 },
    },
  }),

  computed: {
    pageConfig() {
      const { unit, format, orientation, margins } = this.config;
      const doc = jsPDF({ unit, format, orientation });
      const width = doc.internal.pageSize.getWidth();
      const height = doc.internal.pageSize.getHeight();

      return { unit, margins, width, height };
    },
    renderingMsg() {
      const { text, progress, total, percent } = this.rendering;
      return `${text} (${progress}/${total} - ${percent}%)`;
    },
  },

  methods: {
    async progressPrint(progress, total, text) {
      this.rendering.progress = progress;
      this.rendering.total = total;
      this.rendering.percent = Math.round((progress / (total || 1)) * 100);
      this.rendering.text = text;
    },
    async generatePDF() {
      const { unit, format, orientation } = this.config;

      const doc = await this.$html2pdf(
        this.$refs.dataprint.getElementsByClassName("page"),
        { jsPDF: { orientation, unit, format } },
        this.progressPrint
      );
      return doc;
    },
    async printDoc() {
      this.progressPrint(0, 0, "Cargando...");
      const doc = await this.generatePDF();
      doc.autoPrint({ variant: "non-conform" });
      const blob = doc.output("bloburl");
      window.open(blob);
    },
    async downloadDoc() {
      this.progressPrint(0, 0, "Cargando...");
      const doc = await this.generatePDF();
      doc.save(this.config.filename);
    },
    async sendEmailDoc() {
      const doc = await this.generatePDF();
      this.$emit("clickSendEmail", doc);
    },
    downloadJsonDoc() {
      this.$emit("clickDownloadJson");
    },
  },
};
</script>
